<span
  [style.display]="expanded ? 'inline-block' : 'none'"
  [style.position]="startpoint ? '' : 'absolute'"
  [style.top]="'5px'"
  [style.left]="(left - 5).toString() + 'px'"
>
  <ng-container #menuitems></ng-container>
</span>
